import { I18n } from '../enums/i18n.enum';
import { ButtonsMenuTypes } from '../types/languages.type';

export const languagesData: ButtonsMenuTypes[] = [
  // {
  //   id: 0,
  //   name: 'فارسی',
  //   code: I18n.fa,
  // },
  {
    id: 0,
    name: 'English',
    code: I18n.en,
  },
  // {
  //   id: 3,
  //   name: 'کوردی',
  //   code: I18n.ckb,
  // },
  {
    id: 1,
    name: 'Türkçe',
    code: I18n.tr,
  },
  {
    id: 2,
    name: '中国人',
    code: I18n.zh,
  },
  {
    id: 3,
    name: 'العربية',
    code: I18n.ar,
  },
];
